import { useRtoasterRecommendWithCache } from "@/hooks";
import RtRecommendList from "@/components/Rtoaster/RtRecommendList";
import config from "@/lib/config";
/**
 * TvShowRecommend.
 *
 * titleページ用のRtoasterレコメンド
 *
 * @returns {React.ReactElement}
 */

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function TvShowRecommend() {
  var elementIds = [config.rtoasterElementId.title.related, config.rtoasterElementId.title.recommend];

  var _useRtoasterRecommend = useRtoasterRecommendWithCache(elementIds),
      loading = _useRtoasterRecommend.loading;

  if (loading) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(RtRecommendList, {
      header: {
        text: "関連作品"
      },
      elementId: config.rtoasterElementId.title.related
    }), /*#__PURE__*/_jsx(RtRecommendList, {
      header: {
        text: "あなたにおすすめの作品"
      },
      elementId: config.rtoasterElementId.title.recommend
    })]
  });
}